export class GetBranchesReqData {
    includeEmpty: boolean;
    includeDeleted: boolean;

    constructor(includeEmpty: boolean, includeDeleted: boolean) {
        this.includeEmpty = includeEmpty;
        this.includeDeleted = includeDeleted;
    }
}
